import React from 'react';
import {useDispatch} from 'react-redux';

import InfoPopup from '@/components/Popup/InfoPopup';
import appContent from '@/services/content/appContent';
import connectivityService from '@/services/device/connectivityService';
import appRouterService from '@/services/route/appRouterService';
import {hideModalAction} from '@/state/slices/modalSlice';

const getContent = () => {
    const isBle = connectivityService.isBle();
    const content = isBle ? appContent.getClosePairingPopup() : appContent.getCloseConnectingPopup();

    return content;
};

const ConnectionCancellationPopup = ({modalType}) => {
    const dispatch = useDispatch();
    const {icon, title, description, primaryButton, secondaryButton} = getContent();

    const onClose = () => {
        dispatch(hideModalAction(modalType));
    };
    const handleKeepPairingClick = () => {
        onClose();
    };
    const handleGoBackClick = () => {
        onClose();
        appRouterService.forwardToDevicesPage(true);
    };

    return (
        <InfoPopup
            onClose={onClose}
            title={title}
            className='ml:pt-20'
            description={description}
            primaryButton={{
                ariaLabel: primaryButton.alt,
                onClick: handleKeepPairingClick,
                text: primaryButton.text,
            }}
            secondaryButton={{
                ariaLabel: secondaryButton.alt,
                onClick: handleGoBackClick,
                text: secondaryButton.text,
            }}
            icon={icon}
            isBlockerOverlay
            shouldCloseOnOverlayClick={false}
        />
    );
};

export default ConnectionCancellationPopup;
